// import axiosInstance from "utils/AxiosInterceptor";

import {
  GetAllCodesResponse,
  GetAllProjectsResponse,
  GetAllSourcesResponse,
  Project,
  SourceRequestInterface,
  User,
} from "interfaces";
import {
  AcceptInvitationRequest,
  CheckSourceRequest,
  DownloadPinnedAnswersRequest,
  ProjectRequest,
  RemoveUserFromProject,
  SetProjectPreferredRequest,
  ShareProjectRequest,
} from "interfaces/Request";
import axiosInstance from "utils/AxiosInterceptor";

export const getAllProject = async (...args: any) => {
  let url = `api/projects/list?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get<GetAllProjectsResponse>(url);
};

export const getDetailProject = (projectId: string) => {
  return axiosInstance.get<Project>(
    `api/projects/detail?projectId=${projectId}`
  );
};

export const getUsersListToShare = (projectId: string) => {
  return axiosInstance.get<{ usersList: User[] }>(
    `api/projects/users-to-share?projectId=${projectId}`
  );
};

export const shareProject = (shareProjectRequest: ShareProjectRequest) => {
  return axiosInstance.post("api/projects/share", shareProjectRequest);
};

export const acceptInvitationToProject = (payload: AcceptInvitationRequest) => {
  return axiosInstance.post("api/projects/accept-invitation", payload);
};

export const removeUserFromProject = (payload: RemoveUserFromProject) => {
  return axiosInstance.delete(
    `api/projects/remove-user?userId=${payload.userId}&projectId=${payload.projectId}`
  );
};

export const deleteProject = (projectId: string) => {
  return axiosInstance.delete(`api/projects/delete?projectId=${projectId}`);
};

export const leaveProject = (projectId: string) => {
  return axiosInstance.delete(`api/projects/leave?projectId=${projectId}`);
};

export const getProjectSourceArchive = async (
  projectId: string,
  ...args: any
) => {
  let url = `api/projects/archive-sources-list?projectId=${projectId}`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get<GetAllSourcesResponse>(url);
};

export const addNewProject = async (payload: ProjectRequest) => {
  return axiosInstance.post<{ id: string }>("api/projects/add", payload);
};

export const addCodesProject = async (payload: SourceRequestInterface) => {
  return axiosInstance.post("api/projects/add-sources", payload);
};

export const editProject = async (payload: ProjectRequest) => {
  return axiosInstance.put("api/projects/update", payload);
};

export const setProjectePreferred = async (
  payload: SetProjectPreferredRequest
) => {
  return axiosInstance.put("api/projects/preferred", payload);
};

export const getSourceList = async (projectId: string) => {
  return axiosInstance.get(`api/projects/sources-list?projectId=${projectId}`);
};

export const getCodesList = async (projectId: string, ...args: any) => {
  let url = `api/projects/codes-list?projectId=${projectId}`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get<GetAllCodesResponse>(url);
};

export const getDetailCode = async (projectId: string, codeId: number) => {
  return axiosInstance.get(
    `api/projects/code-detail?projectId=${projectId}&codeId=${codeId}`
  );
};

export const getPinnedAnswers = async (projectId: string) => {
  return axiosInstance.get(
    `api/projects/pinned-answers?projectId=${projectId}`
  );
};

export const downloadPinnedAnswers = async (
  payload: DownloadPinnedAnswersRequest
) => {
  return axiosInstance.post(`api/projects/download`, payload, {
    responseType: "blob",
  });
};

export const deleteSourceFromProject = async (
  sourceId: any,
  projectId: any
) => {
  return axiosInstance.delete(
    `api/projects/delete-source?projectId=${projectId}&sourceId=${sourceId}`
  );
};

export const checkSource = async (payload: CheckSourceRequest) => {
  return axiosInstance.put("api/projects/check-source", payload);
};

export const checkLastResetChat = async (projectId: string) => {
  return axiosInstance.put(
    `api/projects/check-last-reset-date?projectId=${projectId}`, {});
};
  